import { render } from "./ShowCostLabel.vue?vue&type=template&id=5813019a"
import script from "./ShowCostLabel.vue?vue&type=script&lang=js"
export * from "./ShowCostLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__